<ion-header class="ion-no-border">
  <ion-toolbar class="picker-toolbar">
    <ion-title>O que você quer criar?</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Fechar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="picker-content">
  <p class="picker-hint">Escolha o tipo de evento que quer adicionar à agenda.</p>

  <div class="picker-options">
    @for (opt of options; track opt.id) {
      <button
        type="button"
        class="picker-option"
        [class.picker-option--single]="opt.id === 'single'"
        [class.picker-option--bulk]="opt.id === 'bulk'"
        [class.picker-option--block]="opt.id === 'block'"
        [class.picker-option--special]="opt.id === 'special'"
        (click)="select(opt.id)"
        [attr.aria-label]="opt.title + ': ' + opt.description">
        <span class="picker-option__icon" aria-hidden="true">
          <ion-icon [name]="opt.icon"></ion-icon>
        </span>
        <span class="picker-option__body">
          <span class="picker-option__title">{{ opt.title }}</span>
          <span class="picker-option__description">{{ opt.description }}</span>
        </span>
        <ion-icon
          name="chevron-forward-outline"
          class="picker-option__chev"
          aria-hidden="true"></ion-icon>
      </button>
    }
  </div>
</ion-content>
